import React, { PropsWithChildren } from 'react';

import { CSSProperties } from 'styled-components';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { LoadingKey } from 'utils/promise';

export interface ModalInjectedProps extends PropsWithChildren {
  closeModal: () => void;
  closeModals: (amount?: number) => void;
  closeAllModals: () => void;
  stack: StackedModal[];
}
export interface StackedModalProps {
  // open?: boolean;
  // closeModal: () => void;
  // closeModals: (amount?: number) => void;
  // closeAllModals: () => void;
  [key: string]: any;
}
export type ModalElementType<P = {}> = React.ReactElement<P & ModalInjectedProps>;
// // 모달의 액션에 관련된 상태들
interface ModalActionProps {
  closeOnBackdropClick?: boolean;
  modalWrapperStyle?: CSSProperties;
  loading?: {
    key: LoadingKey;
  };
}

export interface StackedModal {
  element: React.ReactElement<ModalInjectedProps>;
  modalActionProps?: ModalActionProps;
}

interface ModalStoreState {
  stack: StackedModal[];
  openModal: (element: ModalElementType, modalActionProps?: ModalActionProps, options?: OpenModalOptions) => void;
  closeModal: () => void;
  closeModals: (amount?: number) => void;
  closeAllModals: () => void;
  getStack: () => StackedModal[];
  checkIsModalOpenByModalName: (modalName: string) => boolean;
}

export type OpenModalOptions = {
  replace?: boolean;
};

export const useModalStackStore = create<ModalStoreState>()(
  devtools(
    (set, get) => ({
      stack: [],

      openModal: (element, modalActionProps, options) => {
        const key = (element.type as any)?.displayName || (element.type as any)?.name || 'UnknownModal';

        const { closeModal, closeAllModals, closeModals, getStack } = get();

        const enhancedElement = React.cloneElement(element, {
          key,
          stack: getStack(),
          closeModal,
          closeAllModals,
          closeModals,
        });

        set(
          (state) => {
            let newStack = [...state.stack];

            if (options?.replace) {
              newStack = newStack.slice(0, newStack.length - 1);
            }

            return { stack: [...newStack, { element: enhancedElement, modalActionProps }] };
          },
          false,
          `openModal(${key})`
        );
      },

      closeModal: () => {
        const { stack } = get();
        if (stack.length === 1) {
          get().closeAllModals();
        } else {
          get().closeModals(1);
        }
      },

      closeModals: (amount = 1) => {
        set((state) => ({ stack: state.stack.slice(0, state.stack.length - amount) }), false, `closeModals(${amount})`);
      },

      closeAllModals: () => {
        set({ stack: [] }, false, 'closeAllModals');
      },

      getStack: () => get().stack,

      checkIsModalOpenByModalName: (modalName: string) => {
        const modalStack = get().stack;
        return modalStack.findIndex((modalItem) => modalItem.element.key === modalName) !== -1;
      },
    }),
    { name: 'ModalStackStore' }
  )
);

export const openModal = (
  element: ModalElementType,
  modalActionProps: ModalActionProps,
  options?: OpenModalOptions
) => {
  useModalStackStore.getState().openModal(element, modalActionProps, options);
};

export const closeModal = () => {
  useModalStackStore.getState().closeModal();
};

export const closeAllModals = () => {
  useModalStackStore.getState().closeAllModals();
};

interface UseNoticeModalFlagInter {
  flag: boolean;
  setFlag: (flag: boolean) => void;
}

export const useNoticeModalFlag = create<UseNoticeModalFlagInter>((set) => ({
  flag: false,
  setFlag: (flag: boolean) => set({ flag }),
}));
